export default function attachmentImage_getAspectRatio(imageUrl: string): Promise<number> {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = imageUrl

        img.onload = () => {
            /*const width = img.naturalWidth
            const height = img.naturalHeight

            const gcd = (a: number, b: number): number => {
                if (b === 0) {
                    return a
                }
                return gcd(b, a % b)
            };

            const commonDivisor = gcd(width, height)
            const aspectRatioWidth = width / commonDivisor
            const aspectRatioHeight = height / commonDivisor*/

            resolve(img.naturalWidth/img.naturalHeight)
        }

        img.onerror = () => {
            reject("Error loading image")
        }
    })
}